// extracted by mini-css-extract-plugin
module.exports = {"root":"_2iuTV","logotype":"_3f9qQ","svg":"_2gH9Y"};